<template>
  <div class="ask-question">
    <editWin
      ref="editWinRef"
      :width="600"
      v-model="show"
      :title="faqType.label + 'FAQ-反馈问题'"
      @addSuccess="addSuccess"
      :formInputList="formInputList"
      :isFixed="true"
      addApi="/saasbaihui/feedbackFAQ"
      :titleSplicing="false"
    ></editWin>
  </div>
</template>

<script>
export default {
  props: {
    faqType: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      show: false,
      activeItem: null,
      formInputList: [],
    };
  },
  methods: {
    open(res) {
      this.activeItem = res;
      this.restart();
      this.show = true;
    },
    addSuccess() {
      this.$emit("success");
    },
    restart() {
      this.formInputList = [
        {
          type: "textarea",
          field: "question",
          title: "问题",
          value: "",
          required: true,
          maxlength: 500,
          props: {
            rows: 7,
          },
        },
        {
          type: "input",
          field: "faqType",
          title: "问题类型",
          value: this.faqType.value,
          required: true,
          isHide: true,
        },
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.ask-question {
  .head-title {
    margin-bottom: 20px;
  }
}
</style>
